// @flow
import React, { Component } from 'react'
import PaymentTypeSelect from '../AudienceEdit/PaymentTypeSelect'
import PriceInput from '../AudienceEdit/PriceInput'
import ExpandingDropdown from '../AdvertisementsTable/ExpandingDropdown'
import { translateFunc, translations } from '../../shared/localize'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'
import { linkColor } from '../controls/colors'
import _ from 'lodash'
import { Audience } from '../constants'
import type { Options } from '../types'
import { priceBudgetUpdateUrl } from '../CampaignsTable'

const Item: StyledComponent<Object, any, any> = styled.div`
  padding: 10px 0;
  margin-bottom: -30px;
`
const Buttons: StyledComponent<Object, any, any> = styled.div`
  margin-top: 15px;
`
const Triggers: StyledComponent<Object, any, any> = styled.div`
  text-align: center;
`
const Link: StyledComponent<Object, any, any> = styled.div`
  color: ${linkColor};
  cursor: pointer;
  font-size: ${({ largeFont }: Object) => (largeFont ? '14' : '11')}px;
  display: inline-block;
  border-bottom: 1px dashed rgba(97, 184, 211, 0.5);
  text-decoration: none;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 5px;
  text-align: left;
`

type Props = {|
  audienceType: string,
  paymentType: string,
  price?: string,
  audienceId: number,
  onAudienceStateChange: Function
|}

type State = {|
  paymentType: string,
  price: string,
  isOpen: boolean
|}

export default class PaymentPopup extends Component<Props, State> {
  t: Function
  priceInput: any

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.campaigns_table.payment_popup)

    this.state = {
      price: this.preparedPrice(props.price, props.paymentType),
      paymentType: props.paymentType,
      isOpen: false
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.price, this.props.price)) {
      this.setState({ price: this.preparedPrice(this.props.price, this.props.paymentType) })
    }
  }

  dropdownChanged(isOpen: boolean) {
    if (!isOpen) {
      this.setState({
        paymentType: this.props.paymentType,
        price: this.preparedPrice(this.props.price, this.props.paymentType)
      })
    }
    this.setState({ isOpen })
  }

  submit() {
    const { price, paymentType } = this.state
    const { audienceId, onAudienceStateChange } = this.props

    postJson(priceBudgetUpdateUrl, {
      data: {
        audience_ids: [audienceId],
        param_to_change: 'price',
        change_type: 'set',
        value_change_type: 'absolute',
        value: price,
        payment_type: paymentType
      }
    })
      .done((response) => {
        onAudienceStateChange(response.data.audiences, audienceId)
        this.setState({ isOpen: false })
        window.alert(response.data.result_text.join('\n'))
      })
      .fail(({ responseJSON }: any) => {
        this.priceInput.setErrors(responseJSON.message.value)
      })
  }

  renderPopupContent() {
    const { paymentType } = this.state

    return (
      <Wrapper>
        <PaymentTypeSelect
          options={this.paymentTypeSelectOptions()}
          value={paymentType}
          onChange={(paymentType) => this.setState({ paymentType })}
          hideHints
        />
        {!this.isAuto() && (
          <Item>
            <PriceInput
              ref={(el) => {
                this.priceInput = el
              }}
              value={this.state.price}
              min={0}
              maxAlert={0}
              minRecommended={0}
              effectivePrice={0}
              // disable comments by setting isLoading to true
              isLoading
              autoFocus
              onChange={(price) => {
                this.setState({ price })
              }}
              errors={[]}
            />
          </Item>
        )}
        <Buttons>
          <button className="btn btn-success" onClick={() => this.submit()}>
            {this.t('save_btn')}
          </button>{' '}
          <button className="btn btn-default" onClick={() => this.dropdownChanged(false)}>
            {this.t('cancel_btn')}
          </button>
        </Buttons>
      </Wrapper>
    )
  }

  preparedPrice(price: ?string, paymentType: string): string {
    if (paymentType === 'auto') return ''
    if (!price) return ''

    return price.replace(/\.0*$/, '')
  }

  priceElement() {
    const price = this.preparedPrice(this.props.price, this.props.paymentType)

    if (!price) return null
    if (this.isAuto()) return null

    return (
      <Link largeFont className="offable">
        {price} ₽
      </Link>
    )
  }

  renderPaymentType() {
    const { paymentType } = this.state

    return (
      <div>
        <Link largeFont={this.isAuto()} className="t-PaymentPopup__payment-type offable">
          {this.t(`${paymentType}_cell`)}
        </Link>
      </div>
    )
  }

  renderTrigger() {
    return (
      <Triggers>
        {this.priceElement()}
        {this.renderPaymentType()}
      </Triggers>
    )
  }

  render() {
    return (
      <ExpandingDropdown
        isOpen={this.state.isOpen}
        triggerText={this.renderTrigger()}
        onChange={(isOpen) => this.dropdownChanged(isOpen)}
        inlineBlock
      >
        {this.renderPopupContent()}
      </ExpandingDropdown>
    )
  }

  isAuto() {
    return this.state.paymentType === 'auto'
  }

  // TODO: Duplicate backend logics
  paymentTypeSelectOptions(): Options {
    const options = [
      [this.t('auto'), 'auto'],
      [this.t('cpc'), 'cpc'],
      [this.t('cpm'), 'cpm']
    ]
    return this.props.audienceType === Audience.types.conversions ||
      this.props.audienceType === Audience.types.leadform
      ? [...options, [this.t('cpa'), 'cpa']]
      : options
  }
}
